<template>
  <div class="loader__wrapper">
    <CTooltip :action="show_tooltip" :position="tooltip_position">{{
      tooltip
    }}</CTooltip>
    <div class="loader" :class="{ 'loader--nophoto': !currentAvatar }">
      <img
        class="loader__current"
        :src="
          currentAvatar
            ? currentAvatar
            : require('@/assets/img/avatar-white.svg')
        "
        alt=""
      />
      <p class="loader__help" v-if="!currentAvatar && !loading">
        <svg-icon type="file" classNames="loader__icon" />
        Максимальный размер <br />
        файла 2 МБ (JPEG/PNG)
      </p>
      <div class="loader__progress_ring" v-if="loading">
        <svg
          class="loader__progress_ring--back"
          :width="loaderWidth"
          :height="loaderWidth"
        >
          <circle
            class="loader__circle_below"
            :r="loaderWidth / 2 - loaderBorderWidth * 2"
            :stroke-width="loaderBorderWidth"
            fill="transparent"
            :cx="loaderWidth / 2"
            :cy="loaderWidth / 2"
            stroke="#CCCCCC"
          />
          <circle
            class="loader__circle_above"
            :r="loaderWidth / 2 - loaderBorderWidth * 2"
            :stroke-width="loaderBorderWidth"
            fill="transparent"
            :cx="loaderWidth / 2"
            :cy="loaderWidth / 2"
            stroke="#3A5EEC"
            stroke-dasharray="106.81"
            :stroke-dashoffset="`${106.81 - loadingProgress * 106.81}`"
          />
        </svg>
      </div>
      <div
        v-if="currentAvatar && !loading"
        class="loader__help loader__help--floating"
      >
        <svg-icon type="file" classNames="loader__icon" />
        Загрузить другое фото. <br />
        Максимальный размер <br />
        файла 2 МБ (JPEG/PNG)
      </div>
    </div>
    <avatar-cropper
      @submit="loading = true"
      @completed="loading = false"
      @progress="handleProgress"
      :upload-url="rootUrl + '/api/upload'"
      upload-form-name="file"
      @uploaded="handleUploaded"
      trigger=".loader"
      :labels="{ submit: 'Загрузить', cancel: 'Отмена' }"
    />
  </div>
</template>

<script>
import AvatarCropper from "../AvatarCropper";
import CTooltip from "./CTooltip";

export default {
  name: "CAvatarInput",
  components: { AvatarCropper, CTooltip },
  props: ["currentAvatar", "tooltip", "tooltip_action", "tooltip_position"],
  data() {
    return {
      loading: false,
      loadingProgress: 0,
      loaderWidth: 42,
      loaderBorderWidth: 2,
      rootUrl: process.env.VUE_APP_API_ROOT,
      show_tooltip: this.tooltip_action
    };
  },
  mounted() {
    if (this.currentAvatar) {
      this.$emit("valid");
      this.show_tooltip = false;
    } else {
      this.$emit("invalid");
      this.show_tooltip = true;
    }
    if (!!this.tooltip === false) {
      this.show_tooltip = false;
    }
  },
  methods: {
    handleUploaded(response) {
      this.$emit("input", response.result.file);
      this.$emit("valid");
      this.loadingProgress = 0;
    },
    handleProgress(event) {
      this.loadingProgress = event.loaded / event.total;
    }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100%;
  display: flex;
  justify-items: center;
  border-radius: 12px;
  max-height: 180px;
  overflow: hidden;
  background: #f2f2f2;
  cursor: pointer;
  flex-direction: column;
  position: relative;

  &__wrapper {
    position: relative;
  }
  &--nophoto {
    height: 180px;
    justify-content: center;
    align-content: center;
    padding-top: 22px;
  }

  &__current {
    max-width: 100%;
  }

  &__help {
    font-size: 15px;
    color: #303333;
    display: flex;
    justify-content: center;
    align-items: center;

    &--floating {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      color: #000000;
      background: rgba(242, 242, 242, 0.8);
      transition: opacity 200ms ease;

      &:hover {
        opacity: 1;
      }
    }
  }

  &__progress_ring {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  &__icon {
    margin-right: 10px;
  }
  &__circle_above {
    transform: rotate(-90deg);
    transform-origin: center;
    transition: 200ms ease;
  }
}
</style>
